import './styles.scoped.css'
import {useState} from 'react'
import {Typography, Button, IconButton, FormControl, OutlinedInput, InputAdornment, FormHelperText, Modal} from '@mui/material'
import {Visibility, VisibilityOff, Close} from '@mui/icons-material'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {accountApi} from '../../../../services'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {useMobile} from '../../../../hooks'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen}) => {
    const {setLoading, setMessageBox} = useGlobalStates()
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false)
    const {mobile} = useMobile()
    const form = useForm({
        resolver: yupResolver(
            yup.object().shape({
                new_password: yup.string().required('New Password is required'),
                confirm_password: yup
                    .string()
                    .required('Confirm New Password is required')
                    .oneOf([yup.ref('new_password'), null], 'Confirm New Password does not match'),
            }),
        ),
    })

    const changePassword = data => {
        setLoading(true)
        accountApi
            .changePassword(data)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Password Changed Successfully',
                    description: 'Your password has been updated successfully.',
                })
            })
            .catch(error => {
                setLoading(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    {mobile ? (
                        <>
                            <div className="header">
                                <Typography variant="h6" color="text.primary">
                                    Change Password
                                </Typography>
                                <IconButton onClick={() => setOpen(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <div className="actions">
                                <Button variant="outlined" onClick={() => setOpen(false)} style={{flex: 1}}>
                                    Back
                                </Button>
                                <Button variant="contained" fullWidth onClick={form.handleSubmit(changePassword)} style={{flex: 1}}>
                                    Save
                                </Button>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <Typography variant="h6" color="text.primary" className="title">
                            Change Password
                        </Typography>
                    )}
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        New Password
                    </Typography>
                    <FormControl error={!!form.formState.errors['new_password']} variant="standard" fullWidth>
                        <OutlinedInput
                            placeholder="Enter new password"
                            {...form.register('new_password')}
                            type={showNewPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)} onMouseDown={e => e.preventDefault()}>
                                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <FormHelperText>{form.formState.errors['new_password']?.message}</FormHelperText>
                    </FormControl>
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Confirm New Password
                    </Typography>
                    <FormControl error={!!form.formState.errors['confirm_password']} variant="standard" fullWidth>
                        <OutlinedInput
                            placeholder="Enter confirm new password"
                            {...form.register('confirm_password')}
                            type={showConfirmNewPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                        onMouseDown={e => e.preventDefault()}>
                                        {showConfirmNewPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <FormHelperText>{form.formState.errors['confirm_password']?.message}</FormHelperText>
                    </FormControl>
                    <br />
                    <br />
                    {mobile ? (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <div className="actions">
                            <Button onClick={() => setOpen(false)} variant="outlined" fullWidth>
                                Cancel
                            </Button>
                            <Button variant="contained" fullWidth onClick={form.handleSubmit(changePassword)}>
                                Save Changes
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}
